import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaSignOutAlt, FaRupeeSign } from 'react-icons/fa';
import './Kharch_Aai.css'; 
import topLogo from './logo-placeholder.png'; 

const Kharch_Aai = () => {
    const navigate = useNavigate();

    // --- STATE ---
    const [formData, setFormData] = useState({
        voucherNo: '',
        date: '',
        spenderName: '',
        descSelect: '',
        descText: '',
        amount: ''
    });

    const [showExitModal, setShowExitModal] = useState(false);
    
    // 1. NEW STATE FOR LOADING
    const [isLoading, setIsLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    // --- HANDLERS ---
    const handleYesLogout = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('token'); 
        localStorage.removeItem('isLoggedIn');
        navigate('/'); 
    };

    const handleNoStay = () => setShowExitModal(false);
    const handleManualLogout = () => setShowExitModal(true);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'voucherNo' || name === 'amount') {
            if (value === '' || /^[0-9\b]+$/.test(value)) {
                setFormData({ ...formData, [name]: value });
            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // --- 2. UPDATED SUBMIT HANDLER WITH PROGRESS BAR ---
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.voucherNo || !formData.date || !formData.amount || !formData.spenderName) {
            alert("Please fill all required fields");
            return;
        }

        // START LOADING
        setIsLoading(true);
        setProgress(10); // Start at 10%

        // Simulate progress bar moving while waiting for server
        const progressInterval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 90) return 90; // Stall at 90% until real response comes
                return prev + 10;
            });
        }, 200);

        let currentUsername = 'Guest';
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                currentUsername = parsedUser.name || parsedUser.username || 'Admin';
            } catch (error) {
                currentUsername = storedUser;
            }
        }

        try {
            const response = await fetch('/api/dashboard/add-expense', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    voucherNo: formData.voucherNo,
                    date: formData.date,
                    spenderName: formData.spenderName,
                    descSelect: formData.descSelect,
                    descText: formData.descText,
                    amount: formData.amount,
                    username: currentUsername
                }),
            });

            const result = await response.json();

            // Clear the fake progress interval
            clearInterval(progressInterval);

            if (result.success) {
                // Complete the bar
                setProgress(100);
                
                // Small delay so user sees 100%
                setTimeout(() => {
                    setIsLoading(false); // Hide Modal
                    setProgress(0);      // Reset
                    alert("✅ Expense Saved Successfully!");
                    
                    setFormData({
                        voucherNo: '',
                        date: '',
                        spenderName: '',
                        descSelect: '',
                        descText: '',
                        amount: ''
                    });
                }, 500);

            } else {
                setIsLoading(false);
                alert("❌ Error: " + result.message);
            }

        } catch (error) {
            clearInterval(progressInterval);
            setIsLoading(false);
            console.error("Submission Error:", error);
            alert("❌ Server Connection Error");
        }
    };

    return (
        <div className="details-container">

            {/* --- 3. LOADING OVERLAY (PROGRESS BAR) --- */}
            {isLoading && (
                <div className="loading-overlay">
                    <div className="loading-box">
                        <h3>Processing...</h3>
                        <div className="progress-container">
                            <div 
                                className="progress-bar-fill" 
                                style={{ width: `${progress}%` }}
                            ></div>
                        </div>
                        <p>{progress}%</p>
                    </div>
                </div>
            )}

            {/* --- EXISTING LOGOUT MODAL --- */}
            {showExitModal && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <h3>Warning</h3>
                        <p>Do you want to Sign Out?</p>
                        <div className="modal-actions">
                            <button className="btn-confirm" onClick={handleYesLogout}>Yes</button>
                            <button className="btn-cancel" onClick={handleNoStay}>No</button>
                        </div>
                    </div>
                </div>
            )}

            {/* --- BACKGROUND SHAPES --- */}
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>

            {/* --- REST OF YOUR UI (Header, Form, etc.) --- */}
            <button className="logout-btn" onClick={handleManualLogout}>
                <FaSignOutAlt /> <span>Sign Out</span>
            </button>

            <div className="brand-header">
                <img src={topLogo} alt="Logo" className="brand-logo" />
                <div className="brand-text">
                    <h2>गायत्री परिवार</h2>
                    <h3>अलीराजपुर</h3>
                </div>
            </div>

            <div className="details-header">
                <button className="back-btn" onClick={() => navigate('/home')}>
                   <FaArrowLeft /> Back
                </button>
                <h2><FaRupeeSign /> खर्च राशि</h2>
            </div>

            <div className="form-content-wrapper">
                <div className="prapt-form-card">
                    <form onSubmit={handleSubmit}>
                        
                        {/* INPUTS (Voucher, Date, Name, etc.) - SAME AS BEFORE */}
                        <div className="prapt-form-group">
                            <input type="text" inputMode="numeric" name="voucherNo" placeholder="वाउचर नं." value={formData.voucherNo} onChange={handleChange} className="prapt-input" />
                        </div>
                        <div className="prapt-form-group">
                            <input type="text" name="date" placeholder="दिनांक" value={formData.date} onChange={handleChange} onFocus={(e) => (e.target.type = "date")} onBlur={(e) => (e.target.type = e.target.value ? "date" : "text")} className="prapt-input date-style" />
                        </div>
                        <div className="prapt-form-group">
                            <input type="text" name="spenderName" placeholder="खर्च कर्ता का नाम" value={formData.spenderName} onChange={handleChange} className="prapt-input" />
                        </div>
                        
                        {/* DROPDOWN - SAME AS BEFORE */}
                        <div className="prapt-form-group">
                            <select name="descSelect" value={formData.descSelect} onChange={handleChange} className="prapt-input">
                                <option value="">विवरण का चयन करे</option>
                <option value="यज्ञ व पूजन सामग्री व्यय">यज्ञ व पूजन सामग्री व्यय</option>
                <option value="परीवाजक मानदेय राशि">परीवाजक मानदेय राशि</option>
                <option value="भोजनालय व्यय">भोजनालय व्यय</option>
                <option value="गौशाला हेतु दान">गौशाला हेतु दान</option>
                <option value="समारोह आयोजन व्यय">समारोह आयोजन व्यय</option>
                <option value="विधुत व्यय">विधुत व्यय</option>
                <option value="स्टेशनरी व्यय">स्टेशनरी व्यय</option>
                <option value="कार्यालयीन व्यय">कार्यालयीन व्यय</option>
                <option value="ट्रस्ट द्वारा दी गई भेट राशि">ट्रस्ट द्वारा दी गई भेट राशि</option>
                <option value="भवन मर्मद व्यय">भवन मर्मद व्यय</option>
                <option value="कम्प्यूटर व्यय">कम्प्यूटर व्यय</option>
                <option value="परिव्राज चिकित्सा व्यय">परिव्राज चिकित्सा व्यय</option>
                <option value="परिव्रजा व्यय (पेट्रोल ,डीजल )">परिव्रजा व्यय (पेट्रोल ,डीजल )</option>
                <option value="अंकेक्षण शुल्क">अंकेक्षण शुल्क</option>
                <option value="बैंक में जमा">बैंक में जमा</option>
                <option value="अन्य सामान व्यय">अन्य सामान व्यय</option>
                <option value="मार्ग यात्रा व्यय">मार्ग यात्रा व्यय</option>
                            </select>
                        </div>

                        <div className="prapt-form-group">
                            <input type="text" name="descText" placeholder="विवरण लिखे" value={formData.descText} onChange={handleChange} className="prapt-input" />
                        </div>
                        <div className="prapt-form-group">
                            <input type="text" inputMode="numeric" name="amount" placeholder="खर्च राशि" value={formData.amount} onChange={handleChange} className="prapt-input" />
                        </div>

                        <button type="submit" className="prapt-submit-btn" disabled={isLoading}>
                            {isLoading ? "Saving..." : "! ! खर्च करे ! !"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Kharch_Aai;